import { Component, OnDestroy, OnInit } from '@angular/core';
import { UsersService } from '../../../../services/users/user.service';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTabsModule } from '@angular/material/tabs';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { UserFeedback } from 'allai-admin-shared';
import { OverlayModule } from '@angular/cdk/overlay';
import { OrgDatePipe } from '../../../../lib/org-date.pipe.js';
import { Router } from '@angular/router';
/** The user metric page */
@Component({
	selector: 'app-user-feedback',
	imports: [
		MatIconModule,
		MatButtonModule,
		MatTabsModule,
		MatTableModule,
		MatTableModule,
		OverlayModule,
		OrgDatePipe
	],
	providers: [provideNativeDateAdapter()],
	templateUrl: './user-feedback.component.html',
	styleUrl: './user-feedback.component.scss'
})
export class UserFeedbackComponent implements OnInit, OnDestroy {

	feedbackDataSource: MatTableDataSource<UserFeedback>;

	readonly displayedColumns: (keyof UserFeedback)[] = ['id', 'appointmentId', 'message', 'timestamp','type','organizationId','url'];

	constructor(private usersService: UsersService, private router: Router) {

	}

	ngOnInit() {

		this.usersService.onNewUserDetail.subscribe(() => {
			this.refresh();
		});
	}

	private refresh() {
		let userDetail = this.usersService.userDetail;
		let data = userDetail.feedback;
		this.feedbackDataSource = new MatTableDataSource<UserFeedback>(data);
	}

	ngOnDestroy() {
	}

	/** Open an appointment that was clicked on */
	goto(row: UserFeedback) {
		let url = this.router.serializeUrl(this.router.createUrlTree(['/', 'appointments', row.appointmentId]));
		window.open(url, `_appointment_${row.appointmentId}`);
	}
}
